﻿import jquery from 'jquery';

class GeoRepository {
    constructor(geoRepositoryDto) {
        this.__geoRepositoryDto = geoRepositoryDto;
    }


    getZonas(codPob) {

        return new Promise((resolve, reject) => {
            const request = jquery.post(this.__geoRepositoryDto.urlGetDistritosZonas, {
                navigationParms: this.__geoRepositoryDto.navParamsLista,
                codPob
            });

            request.done((data) => { return resolve(data); });
            request.error((err) => { return reject(err); });
        });
    }


}

export default GeoRepository;